import _objectSpread from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4fc0a5e5"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "emial-style"
  }, "Email Address", -1);
});

var _hoisted_2 = /*#__PURE__*/_createTextVNode("Update");

import DefaultDialog from '@/components/DefaultDialog';
import { ref, reactive } from 'vue';
import { apiTestUserBind } from '@/api/common';
import { emailVisible } from './data.ts';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var subBtnLoading = ref(false);
    var ruleFormRef = ref();
    var form = reactive({
      email: ''
    });
    var rulesForm = reactive({
      email: [{
        required: true,
        type: 'email',
        message: 'Please enter a valid email',
        trigger: ['blur', 'change']
      }]
    }); // 提交

    function submitForm(_x) {
      return _submitForm.apply(this, arguments);
    }

    function _submitForm() {
      _submitForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formEl) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (formEl) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return formEl.validate(function (valid, fields) {
                  if (valid) {
                    subBtnLoading.value = true;
                    apiTestUserBind(_objectSpread({}, form)).then(function (_ref) {// resultEmailMap[data] && resultEmailMap[data]()

                      var data = _ref.data;
                    }).finally(function () {
                      subBtnLoading.value = false;
                    });
                  } else {
                    console.log('error submit!', fields);
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _submitForm.apply(this, arguments);
    }

    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createBlock(_unref(DefaultDialog), {
        modelValue: _unref(emailVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _isRef(emailVisible) ? emailVisible.value = $event : null;
        }),
        width: "31%",
        "custom-class": "default-dialog no-footer-dialog",
        title: "Update Information"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: _unref(form),
            rules: _unref(rulesForm),
            "label-width": "0"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                prop: "email"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_1, _createVNode(_component_el_input, {
                    maxlength: "50",
                    modelValue: _unref(form).email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(form).email = $event;
                    }),
                    class: "item-input"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_button, {
                type: "primary",
                class: "project-btn",
                loading: subBtnLoading.value,
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return submitForm(ruleFormRef.value);
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_2];
                }),
                _: 1
              }, 8, ["loading"])];
            }),
            _: 1
          }, 8, ["model", "rules"])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});